import { io } from "socket.io-client";
 
let socket = null;
 
export function getSocket() {
  // Only enable socket for "payu" flow
  if (process.env.REACT_APP_PAYMENT_TYPE !== "payu") return null;
 
  if (!socket) {
    const SOCKET_URL = process.env.REACT_APP_PAYMENT_NODE_URL;
    if (!SOCKET_URL) {
      console.warn("REACT_APP_PAYMENT_NODE_URL is missing.");
      return null;
    }
    socket = io(SOCKET_URL, {
      transports: ["websocket"],
      reconnection: true,
    });
  }
  return socket;
}
 
export function destroySocket() {
  if (socket) {
    try {
      socket.removeAllListeners?.();
    } catch { }
    socket.disconnect();
    socket = null;
  }
}
